import { useFlags } from 'launchdarkly-react-client-sdk';

export enum FEATURE_FLAG {
  DATADOG_INIT_OPTIONS = 'datadog-init-options',
  DATADOG_START_SESSION_REPLAY_RECORDING = 'datadog-start-session-replay-recording',
  UNMIND_MEET_ENABLED = 'talk-connect-unmind-meet',
}

export const useFeatureFlag = (flag: FEATURE_FLAG) => {
  const flags = useFlags();

  return flags[flag];
};
